import service from "./service"

const retrieveConsumerReport = async (payload) => {
    return service(payload)
}

export default retrieveConsumerReport
